export const billableSpeeds = [
	{
		speed: 150,
		unit: 'Mbps'
	},
	{
		speed: 250,
		unit: 'Mbps'
	},
	{
		speed: 500,
		unit: 'Mbps'
	},
	{
		speed: 1,
		unit: 'Gbps'
	},
	{
		speed: 2.5,
		unit: 'Gbps'
	},
	{
		speed: 10,
		unit: 'Gbps'
	}
]
